import { struct } from 'io-ts/Decoder';

import { Id as JobId } from '../../../job/Id';
import { JobId as StageId } from '../../../job/stage/Id';

export const Params = struct({
	jobId: JobId,
	stageId: StageId,
});
